import React from "react";
import styled from "styled-components";

const Heading = styled.h2`
  color: #45a049;
  margin-top: 0;
`;

const Paragraph = styled.p`
  color: #aaaaaa;
  line-height: 1.6;
`;

const GettingStarted = () => {
  return (
    <div>
      <Heading>Getting Started</Heading>
      <Paragraph>
        Welcome to Pingcraft Docs! This page will help you get started with your project.
      </Paragraph>
      <Paragraph>
        Here's a quick overview of what you can do:
        <ul>
          <li>Set up your environment</li>
          <li>Install necessary dependencies</li>
          <li>Explore the docs sidebar for more details</li>
        </ul>
      </Paragraph>
    </div>
  );
};

export default GettingStarted;